/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Secret_AddInputs */



/**
* | output |
* | --- |
* | "Add secret" |
*
* @param {Partner_Connectors_Secret_AddInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_secret_add = /** @type {((inputs?: Partner_Connectors_Secret_AddInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Secret_AddInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Secret hinzufügen")
	return /** @type {LocalizedString} */ ("Add secret")
});